import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg077StudentColour = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "student-colour",
	viewBox: "0 0 702.48 889.49",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-077-1{fill:#f2f2f2}.cls-077-12,.cls-077-14,.cls-077-2,.cls-077-3,.cls-077-5,.cls-077-6,.cls-077-8,.cls-077-9{fill-rule:evenodd}.cls-077-3{fill:#ffd98e}.cls-077-10,.cls-077-11,.cls-077-13,.cls-077-4,.cls-077-7{fill:none;stroke-linecap:round;stroke-linejoin:round}.cls-077-11,.cls-077-4{stroke:#ff8364}.cls-077-4{stroke-width:5.73px}.cls-077-5{fill:#d18c65}.cls-077-6{fill:#ff8364}.cls-077-13,.cls-077-7{stroke:#ffd98e}.cls-077-7{stroke-width:2.83px}.cls-077-8{fill:#6bd5e1}.cls-077-9{fill:#dfdfdf}.cls-077-10{stroke:#6bd5e1}.cls-077-10,.cls-077-11{stroke-width:3.11px}.cls-077-12{fill:#1b3c87}.cls-077-13{stroke-width:4.23px}.cls-077-14{fill:#e49d75}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Layer_1-2",
		"data-name": "Layer 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M623.07 143.07c52.35 64.75 86.21 135.78 78.25 199.05-7.77 63.08-57.32 118.58-109.7 195.53-52.35 77.14-107.84 175.93-187.76 200.53-80.1 24.6-184.62-24.79-266.94-101.93S-5.52 454.59.4 355.81s77.7-191.65 160-256.39S335.6-2 417.55 9s152.98 69.33 205.52 134.07",
				className: "cls-077-1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M334.81 433.46c54 0 83 36.08 88.39 72.72 5.48 37.48-.77 68.51.79 113.82 1.06 30.51 14.49 50.89 23.1 78.09s-221.18 34.06-219.81 8.62 17.81-51.5 18.4-83.19c.6-32.31-4-51.7-3.37-104.26.47-41.49 38.48-85.8 92.5-85.8",
				className: "cls-077-2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M113.09 888.29c-2.07-25.54 9.32-116.62 44.53-184.63 131.51-72.83 296.51-38.14 361.75 0 22.09 22.44 38.06 171.52 33.23 182.22",
				className: "cls-077-3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M189 885.88c2.07-16.57 5.35-43.27 10.7-68m280.97 68c-2.07-16.57-5.35-43.27-10.7-68",
				className: "cls-077-4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M251.34 551.72A14.63 14.63 0 1 1 266 566.34a14.63 14.63 0 0 1-14.66-14.62m134.16 0a14.63 14.63 0 1 1 14.63 14.62 14.63 14.63 0 0 1-14.63-14.62",
				className: "cls-077-5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M393.07 299.87c-14.76-11.51-18.4 1.35-20.71 9s-2.14 21.14 9.43 20.85c10.14 9.09 19.58-2.68 22.48-8.66s10.02-18.95-11.2-21.19",
				className: "cls-077-6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M402.83 291.67c-5.09 1.79-7.95 4.23-9.57 8.47",
				className: "cls-077-7"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M296.82 368.18A17.14 17.14 0 1 1 314 385.31a17.14 17.14 0 0 1-17.18-17.13",
				className: "cls-077-8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m178.13 375.74 47.47-12.05 19.23 75.78-47.46 12Z",
				className: "cls-077-9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m188.13 384.09 32.66-8.29 2.52 9.93-32.66 8.27Z",
				className: "cls-077-6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m193.39 404.8 32.66-8.29m-29.92 19.07 32.67-8.29M199 426.83l32.69-8.3m-29.95 19.17 12.82-3.26m14.73-3.74 5.14-1.3",
				className: "cls-077-10"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m146.66 203.68 122.84-58.49 38.39 80.61-122.84 58.5Z",
				className: "cls-077-9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m189.14 266.47 12.22-35.77 22.77 4.3 8.94-44.11 22 3.66 6.4-31.12",
				className: "cls-077-11"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M197.05 233a6.33 6.33 0 1 1 8.45 3 6.33 6.33 0 0 1-8.45-3m30.6-38.38a6.34 6.34 0 1 1 8.45 3 6.33 6.33 0 0 1-8.45-3m232.69 67.98A21.7 21.7 0 1 1 482 284.3a21.7 21.7 0 0 1-21.66-21.7",
				className: "cls-077-3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M518.67 258.81a25 25 0 0 1-24 31.76 25 25 0 0 1-4.87-.47",
				className: "cls-077-11"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M468.88 279.08 460.56 294l34.35 5.52-3.76-17.38",
				className: "cls-077-3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M476.92 262.6a5.12 5.12 0 1 1 5.12 5.12 5.1 5.1 0 0 1-5.12-5.12",
				className: "cls-077-12"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M512.17 257.48a5.12 5.12 0 1 1 5.12 5.12 5.13 5.13 0 0 1-5.12-5.12",
				className: "cls-077-3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m100.91 99.47 32.09 8.67-31.6 117-32.09-8.64Z",
				className: "cls-077-6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m79.51 178.73 17.67 4.78M73.9 199.49l17.68 4.77M85.11 158l17.68 4.78m-12.07-25.55 17.67 4.77m-12.07-25.52 17.68 4.77",
				className: "cls-077-13"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m431.43 75.21 121.17 29.25-20 82.62-121.12-29.26Z",
				className: "cls-077-9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M503.9 164.78a13.06 13.06 0 1 1 9.63 15.76 13.06 13.06 0 0 1-9.63-15.76",
				className: "cls-077-6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m507.76 175.53-8.71 22.71 12.16-2.75 7.81 7.25 1.57-24.74",
				className: "cls-077-6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m438.59 96.64 95.66 23.1m-101.2-.43 57.77 13.95",
				className: "cls-077-10"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m239.14 86.48-13-14.09 18.7-4.23 18.71-4.23-5.69 18.32-5.69 18.31Z",
				className: "cls-077-8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M497.43 381.88 479.62 389l2.73-19 2.73-19 15.07 11.85 15.08 11.86Z",
				className: "cls-077-3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M351.24 153a9.3 9.3 0 1 1 9.3 9.3 9.3 9.3 0 0 1-9.3-9.3",
				className: "cls-077-11"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M91.4 308.8a9.3 9.3 0 1 1 9.3 9.3 9.3 9.3 0 0 1-9.3-9.3",
				className: "cls-077-3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M301.81 606.75H364s.29 64.25 0 89.53c0 10.43-62.17 9.24-62.17 0Z",
				className: "cls-077-5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M270 545.32c0-47.72 29-86.41 64.83-86.41s64.84 38.69 64.84 86.41-29 86.42-64.84 86.42S270 593.05 270 545.32",
				className: "cls-077-14"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M369.84 452.72c-16.47 38.27-84.71 75.63-113.45 84.37-4.54-22.85 24.87-120.18 113.45-84.37",
				className: "cls-077-2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M333.37 451.54c-12.47 4.75 28.07 69.59 76.65 85.55 19.83-28.23-25.89-86.9-76.65-85.55",
				className: "cls-077-2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M426.07 17.13a17.14 17.14 0 1 1 17.13 17.13 17.13 17.13 0 0 1-17.13-17.13",
				className: "cls-077-3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M130.62 467.56a16 16 0 1 1 16 16 16 16 0 0 1-16-16",
				className: "cls-077-10"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M485.13 460.82a9.31 9.31 0 1 1 9.31 9.3 9.3 9.3 0 0 1-9.31-9.3",
				className: "cls-077-11"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M623.07 143.82c52.35 64.74 86.21 135.78 78.25 199C693.55 406 644 461.44 591.62 538.4c-52.35 77.14-107.84 175.92-187.76 200.52-80.1 24.61-184.62-24.78-266.94-101.92S-5.52 455.34.4 356.55s77.7-191.64 160-256.39S335.6-1.21 417.55 9.7s152.98 69.37 205.52 134.12",
				className: "cls-077-1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M334.81 434.2c54 0 83 36.09 88.39 72.73 5.48 37.47-.77 68.5.79 113.81 1.06 30.52 14.49 50.89 23.1 78.1s-221.18 34.06-219.81 8.61 17.81-51.5 18.4-83.19c.6-32.3-4-51.7-3.37-104.25.47-41.5 38.48-85.81 92.5-85.81",
				className: "cls-077-2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M113.09 889c-2.07-25.54 9.32-116.62 44.53-184.62 131.51-72.83 296.51-38.15 361.75 0 22.09 22.44 38.06 171.51 33.23 182.21",
				className: "cls-077-3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M189 886.62c2.07-16.57 5.35-43.27 10.7-68m280.97 68c-2.07-16.57-5.35-43.27-10.7-68",
				className: "cls-077-4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M251.34 552.46A14.63 14.63 0 1 1 266 567.08a14.63 14.63 0 0 1-14.66-14.62m134.16 0a14.63 14.63 0 1 1 14.63 14.62 14.63 14.63 0 0 1-14.63-14.62",
				className: "cls-077-5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M393.07 300.62c-14.76-11.52-18.4 1.35-20.71 9s-2.14 21.14 9.43 20.85c10.14 9.1 19.58-2.67 22.48-8.65s10.02-18.96-11.2-21.2",
				className: "cls-077-6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M402.83 292.41c-5.09 1.79-7.95 4.23-9.57 8.47",
				className: "cls-077-7"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M296.82 368.92A17.14 17.14 0 1 1 314 386.05a17.13 17.13 0 0 1-17.18-17.13",
				className: "cls-077-8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m178.13 376.48 47.47-12.05 19.23 75.78-47.46 12.05Z",
				className: "cls-077-9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m188.13 384.83 32.66-8.29 2.52 9.93-32.66 8.29Z",
				className: "cls-077-6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m193.39 405.55 32.66-8.3m-29.92 19.08L228.8 408M199 427.57l32.69-8.3m-29.95 19.17 12.82-3.25m14.73-3.75 5.14-1.3",
				className: "cls-077-10"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m146.66 204.43 122.84-58.5 38.39 80.62L185.05 285Z",
				className: "cls-077-9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m189.14 267.21 12.22-35.76 22.77 4.24 8.94-44.11 22 3.66 6.4-31.11",
				className: "cls-077-11"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M197.05 233.79a6.34 6.34 0 1 1 8.45 3 6.35 6.35 0 0 1-8.45-3m30.6-38.43a6.34 6.34 0 1 1 8.45 3 6.33 6.33 0 0 1-8.45-3m232.69 67.98A21.7 21.7 0 1 1 482 285a21.7 21.7 0 0 1-21.66-21.66",
				className: "cls-077-3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M518.67 259.56a25 25 0 0 1 .94 6.8 24.95 24.95 0 0 1-29.82 24.48",
				className: "cls-077-11"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m468.88 279.82-8.32 14.89 34.35 5.53-3.76-17.39",
				className: "cls-077-3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M476.92 263.34a5.12 5.12 0 1 1 5.12 5.12 5.1 5.1 0 0 1-5.12-5.12",
				className: "cls-077-12"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M512.17 258.22a5.12 5.12 0 1 1 5.12 5.12 5.1 5.1 0 0 1-5.12-5.12",
				className: "cls-077-3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m100.91 100.21 32.09 8.68-31.6 117-32.12-8.67Z",
				className: "cls-077-6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m79.51 179.48 17.67 4.77M73.9 200.23 91.58 205m-6.47-46.27 17.68 4.77M90.72 138l17.67 4.77m-12.07-25.55L114 122",
				className: "cls-077-13"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m431.43 76 121.17 29.21-20 82.61-121.12-29.26Z",
				className: "cls-077-9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M503.9 165.52a13.06 13.06 0 1 1 9.63 15.76 13.06 13.06 0 0 1-9.63-15.76",
				className: "cls-077-6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M507.76 176.28 499.05 199l12.16-2.76 7.81 7.25 1.57-24.75",
				className: "cls-077-6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m438.59 97.39 95.66 23.1m-101.2-.43L490.82 134",
				className: "cls-077-10"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m239.14 87.22-13-14.08 18.7-4.23 18.71-4.23-5.7 18.32-5.69 18.32Z",
				className: "cls-077-8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m497.43 382.62-17.81 7.13 2.73-19 2.73-19 15.07 11.85 15.08 11.85Z",
				className: "cls-077-3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M351.24 153.76a9.3 9.3 0 1 1 9.3 9.3 9.3 9.3 0 0 1-9.3-9.3",
				className: "cls-077-11"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M91.4 309.54a9.3 9.3 0 1 1 9.3 9.3 9.3 9.3 0 0 1-9.3-9.3",
				className: "cls-077-3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M301.81 607.49H364s.29 64.25 0 89.54c0 10.43-62.17 9.23-62.17 0Z",
				className: "cls-077-5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M270 546.07c0-47.73 29-86.41 64.83-86.41s64.84 38.68 64.84 86.41-29 86.41-64.84 86.41S270 593.79 270 546.07",
				className: "cls-077-14"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M369.84 453.46c-16.47 38.27-84.71 75.64-113.45 84.38-4.54-22.84 24.87-120.18 113.45-84.38",
				className: "cls-077-2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M333.37 452.28C320.9 457 361.44 521.87 410 537.84c19.85-28.24-25.87-86.9-76.63-85.56",
				className: "cls-077-2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M426.07 17.88A17.14 17.14 0 1 1 443.2 35a17.13 17.13 0 0 1-17.13-17.12",
				className: "cls-077-3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M130.62 468.3a16 16 0 1 1 16 16 16 16 0 0 1-16-16",
				className: "cls-077-10"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M485.13 461.56a9.31 9.31 0 1 1 9.31 9.3 9.3 9.3 0 0 1-9.31-9.3",
				className: "cls-077-11"
			})
		]
	})]
});
export default Svg077StudentColour;
